import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://raintreechinesemedicine.com.au'

export function Canonical() {
	const { pathname } = useLocation()

	useEffect(() => {
		const url = new URL(pathname || '/', SITE_URL)
		let linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
		if (!linkEl) {
			linkEl = document.createElement('link')
			linkEl.setAttribute('rel', 'canonical')
			document.head.appendChild(linkEl)
		}
		linkEl.setAttribute('href', url.toString())
	}, [pathname])

	return null
}


